// Mock data for BIMCORP MX

// Plan names stay in English intentionally.
// Subtitles, intro lines, bullets, and fee labels have EN + ES variants.
export const PRICING = {
  startCorp: {
    name: "Incorporate",
    subtitle: { en: "The Foundation", es: "La base legal" },
    price: "999",
    type: "one-time",
    includesIntro: { en: null, es: null },
    features: {
      en: [
        "Full company incorporation",
        "Foreign investment registration (RNIE)."
      ],
      es: [
        "Constitución completa de la sociedad",
        "Inscripción ante el Registro Nacional de Inversiones Extranjeras (RNIE)."
      ]
    }
  },
  launchCorp: {
    name: "Full Launch",
    subtitle: { en: "Operational Readiness", es: "Listo para operar" },
    price: "2,750",
    type: "one-time",
    includesIntro: {
      en: "Everything in the Incorporate plan, plus:",
      es: "Todo lo incluido en Incorporate, más:"
    },
    features: {
      en: [
        "Mexican Tax ID (RFC) registration",
        "e.firma (Electronic Signature)",
        "Corporate bank account setup"
      ],
      es: [
        "Inscripción al RFC",
        "e.firma",
        "Apertura de cuenta bancaria corporativa"
      ]
    }
  },
  runCorp: {
    name: "Corporate Compliance",
    subtitle: { en: "Full Management", es: "Gestión continua" },
    setupPrice: "2,750",
    monthlyPrice: "175",
    type: "setup + monthly",
    includesIntro: {
      en: "Full Launch setup plus managed compliance and also:",
      es: "Full Launch más gestión de cumplimiento corporativo:"
    },
    features: {
      en: [
        "Statutory books",
        "Share certificate issuance",
        "Annual shareholder meeting management",
        "Copyright registration"
      ],
      es: [
        "Libros corporativos",
        "Emisión de certificados accionarios",
        "Gestión de la asamblea anual de accionistas",
        "Registro de marca"
      ]
    }
  }
};

// Convenience helper — returns a pricing plan with strings for the given language
export const getLocalizedPlan = (planKey, language) => {
  const plan = PRICING[planKey];
  if (!plan) return null;
  return {
    ...plan,
    subtitle: plan.subtitle[language] || plan.subtitle.en,
    includesIntro: plan.includesIntro[language] || plan.includesIntro.en,
    features: plan.features[language] || plan.features.en
  };
};

export const TRUST_POINTS = [
  { icon: "Scale", label: "Lawyer-led" },
  { icon: "FileCheck", label: "Notary-backed" },
  { icon: "Globe", label: "Fully online" },
  { icon: "Target", label: "Tailored" }
];

export const SERVICES = [
  { icon: "Building2", key: "companyIncorporation" },
  { icon: "FileText", key: "rfcSetup" },
  { icon: "Landmark", key: "bankAccount" },
  { icon: "Users", key: "governance" }
];

export const SPECIAL_SERVICES = [
  { icon: "MapPin", key: "restrictedZone" },
  { icon: "Home", key: "landRealEstate" },
  { icon: "Network", key: "tailoredOwnership" }
];

export const WHO_ITS_FOR = [
  { icon: "Rocket", key: "founders" },
  { icon: "TrendingUp", key: "foreignInvestors" },
  { icon: "Briefcase", key: "operators" },
  { icon: "GitBranch", key: "projectBuilders" }
];

export const HOW_IT_WORKS_STEPS = [
  { number: "01", key: "step1" },
  { number: "02", key: "step2" },
  { number: "03", key: "step3" }
];

export const FAQ_ITEMS = [
  { qKey: "q1", aKey: "a1" },
  { qKey: "q2", aKey: "a2" },
  { qKey: "q3", aKey: "a3" },
  { qKey: "q4", aKey: "a4" },
  { qKey: "q5", aKey: "a5" },
  { qKey: "q6", aKey: "a6" },
  { qKey: "q7", aKey: "a7" },
  { qKey: "q8", aKey: "a8" },
  { qKey: "q9", aKey: "a9" }
];

export const CONTACT_INFO = {
  email: "hello@bimcorp.mx",
  phone: "+52 5545629769",
  whatsapp: "https://wa.me/525545629769",
  calendly: "https://calendly.com/bimcorpmx/intro-call"
};

// Wizard recommendation logic — returns a route key.
// Resolve the displayed copy via the `wizard.recommendations.*` translation keys.
export const getRecommendation = (wizardData) => {
  const {
    rfcNeeded,
    bankAccountNeeded,
    governanceNeeded,
    landRestrictedZone,
    tailoredStructure
  } = wizardData;

  if (landRestrictedZone === 'yes' || tailoredStructure === 'yes') {
    return {
      route: 'customProject',
      pricing: { type: 'custom' }
    };
  }

  if (governanceNeeded === 'yes') {
    return {
      route: 'runCorp',
      planName: PRICING.runCorp.name,
      pricing: PRICING.runCorp
    };
  }

  if (rfcNeeded === 'yes' || bankAccountNeeded === 'yes') {
    return {
      route: 'launchCorp',
      planName: PRICING.launchCorp.name,
      pricing: PRICING.launchCorp
    };
  }

  return {
    route: 'startCorp',
    planName: PRICING.startCorp.name,
    pricing: PRICING.startCorp
  };
};
